import { render } from "./risk_categories.html?vue&type=template&id=4d112574&external"
import script from "./risk_categories.js?vue&type=script&lang=js&external"
export * from "./risk_categories.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__